import {fsa, fsaError, fsaPayload} from '../helpers'

export const CREATE_APPOINTMENT = 'create mytime appointment'
/**
 * @param {Object} fields  An object of form values, keyed by field name
 */
export const createAppointment = fsaPayload(CREATE_APPOINTMENT)

export const CREATE_APPOINTMENT_PENDING = 'create mytime appointment pending'
export const createAppointmentPending = fsa(CREATE_APPOINTMENT_PENDING)

export const CREATE_APPOINTMENT_SUCCESS = 'create mytime appointment success'
/**
 * @param {Object} fields  An object of form values, keyed by field name
 */
export const createAppointmentSuccess = fsaPayload(CREATE_APPOINTMENT_SUCCESS)

export const CREATE_APPOINTMENT_FAILURE = 'create mytime appointment failure'
export const createAppointmentFailure = fsaError(CREATE_APPOINTMENT_FAILURE)

/**
 * Handles form submission for Appointment Confirmation. Accepts `resolve` and
 * `reject` as a way of interfacing with redux-form's submission handler.
 *
 * @param {Object}   fields          An object of form values, keyed by field name
 * @param {Function} resolve         Resolve the Promise of form submission
 * @param {Function} reject          Reject the Promise of form submission
 * @param {Boolean}  savePartnerInfo Whether to attempt saving partner info or not
 */
export const SUBMIT_APPOINTMENT_FORM = 'showroom confirmation page/submit appointment form'
export const submitAppointmentForm = fsaPayload(SUBMIT_APPOINTMENT_FORM)
